<div class="sgt-origem-input-group">
    <div class="input-group">
        <div class="input-group-prepend">
            <span class="input-group-text">
                <i class="{{origem | origemIcon}}"></i>
            </span>
        </div>
        <input type="text" class="form-control" [value]="origem | origem" disabled="disabled" readonly="readonly" title="{{origem | origem}}">
    </div>
</div>